import type { UserStateInterface } from '@model/user';
import { getBrowserDiagnosticIdentity } from '@module/visitorIdentity.js';

/** 官网访客身份与 RTC token 绑定身份分开；游客名复用持久化设备 ID。 */
export function buildWebsiteUserQuery(user: Pick<UserStateInterface, 'userID' | 'username'>, deviceId: string) {
  return {
    current_uid: user.userID ? String(user.userID) : '',
    current_user_name: user.userID ? user.username : `访客${deviceId.slice(-6)}`
  };
}

/** 飞书诊断关联字段；账号ID跨登录设备稳定，访客ID仅在当前存储环境稳定。 */
export function buildWebsiteDiagnosticIdentity(user: Pick<UserStateInterface, 'userID' | 'username'>) {
  const browser = getBrowserDiagnosticIdentity();
  return { ...browser, ...buildWebsiteUserQuery(user, browser.device_id), identity_type: user.userID ? 'user' : 'visitor' };
}
